"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const maintenance_icon_svg_1 = __importDefault(require("../../../assets/images/maintenance-icon.svg"));
const ServicesWrapper_1 = __importDefault(require("./servicesWrapper/ServicesWrapper"));
const ServiceCard_1 = __importDefault(require("./serviceCard/ServiceCard"));
require("./Services.scss");
const MOBILE_WIDTH = 992;
const Services = () => {
    (0, react_1.useEffect)(() => {
        document.title = `360 Suítes - Serviços`;
    }, []);
    return (react_1.default.createElement("div", { className: "Services" },
        react_1.default.createElement(ServicesWrapper_1.default, { descriptionTitle: "Su\u00EDtes" },
            react_1.default.createElement("div", { className: "cards-container" },
                react_1.default.createElement(ServiceCard_1.default, { icon: react_1.default.createElement("img", { className: "service-icon", src: maintenance_icon_svg_1.default }), text: (react_1.default.createElement("div", { className: "service-name" },
                        "Manuten\u00E7\u00E3o &",
                        ' ',
                        react_1.default.createElement("b", null, "Solicita\u00E7\u00F5es"))), to: "/minha-conta/manutencao" })))));
};
exports.default = Services;
